import billableEventsAllComponent from './billable_events.all.component';

let billableEventsAllModule = angular.module('billableEventsAll', [])

    .component('billableEventsAll', billableEventsAllComponent)

    .name;

export default billableEventsAllModule;


// WEBPACK FOOTER //
// ./client/app/components/tnt_billing/components/billable_events/all/index.js